import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {TicketMyResultVo} from '../../common/shared/api/nicolas/vo/TicketMyResultVo.interface';

/**
 * 보유 이용권 조회
 *
 * Origin: pageNicolasApi.getTicketMy
 * API: GET /api/v1/ticket/my
 */
export async function getTicketMy(
  {
    seriesId,
    includeSingle,
    onlyPaidTicket,
    includeWaitfree,
  }: {
    seriesId: number;
    includeSingle?: boolean;
    onlyPaidTicket?: boolean;
    includeWaitfree?: boolean;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & {result: TicketMyResultVo}> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/ticket/my',
    {
      method: 'GET',
      params: {
        series_id: seriesId,
        ...(includeSingle !== undefined && {include_single: includeSingle}),
        ...(onlyPaidTicket !== undefined && {only_paid_ticket: onlyPaidTicket}),
        ...(includeWaitfree !== undefined && {
          include_waitfree: includeWaitfree,
        }),
      },
    },
    options
  );
  return response.data;
}
